<template>
  <div class="decorative-wrap">
    <div class="decorative-bg" :class="decorationClass"></div>

    <div class="decorative-content" :style="discountStyle">
      <slot></slot>
    </div>

    <slot name="bottom"></slot>

  </div>
  
</template>

<script>

export default {
  components: {
  },
  props: {
    options: {
      type: Object,
      default: {
        blur: false,
        shine: false,
        couponBlur: false,
        scale: 1,
        opacity: 1,
      },
    },
  },
  computed: {
    decorationClass() {
      if (!this.options) return [];
      const classList = [];
      this.options.blur && classList.push('blur');
      this.options.couponBlur && classList.push('coupon-blur');
      this.options.shine && classList.push('shine');
      this.options.topShine && classList.push('top-shine');
      return classList;
    },
    discountStyle() {
      if (!this.options) return {};
      return {
        opacity: this.options.opacity || 1,
        // transform: `scale(${this.options.scale || 1})`, // 占用原区域
        zoom: this.options.scale || 1, // 不占用原区域
      };
    },
  },
  data() {
    return {
    };
  },
  watch: {
  },
  methods: {
  },
};
</script>

<style lang="less" scoped>
.decorative-wrap {
  position: relative;
  .decorative-bg {
    &.blur {
      &::before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        box-shadow: 3px 3px 36px 0px rgba(255,233,181,0.78);
        border-radius: 16px;
      }
    }
    &.coupon-blur {
      &::before {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        transform: scale(1.05, 1.23);
        background: url(../../assets/imgs/activity/three-order-activity/coupon-blur.png) no-repeat center;
        background-size: 100% 100%;
        border-radius: 16px;
      }
    }
    &.shine {
      &::after {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        transform: scale(1.9) rotate(180deg);
        background: url(../../assets/imgs/activity/three-order-activity/shine.png) no-repeat center;
        background-size: 100% 100%;
      }
    }
    &.top-shine {
      &::after {
        content: '';
        width: 686px;
        height: 544px;
        position: absolute;
        top: -308px;
        left: 50%;
        transform: translateX(-50%);
        background: url(../../assets/imgs/activity/three-order-activity/top-shine.png) no-repeat center;
        background-size: 100% 100%;
      }
    }
  }
  .decorative-content {
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/activity/decorative-wrap.vue